// extracted by mini-css-extract-plugin
module.exports = {"responsiveContainer":"ResponsiveContainer_responsiveContainer__5oOlX","content":"ResponsiveContainer_content__EX3O5","fluid":"ResponsiveContainer_fluid__i_qea"};